import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

export const Wrapper = styled(Box)<{
  $backgroundColor?: Maybe<string>;
  backgroundOffset: number;
  backgroundSrc?: Maybe<string>;
}>`
  position: relative;

  ${({ $backgroundColor, backgroundOffset, backgroundSrc, theme }) => css`
    ${theme.media.md.up} {
      background-color: transparent;
      width: 100%;
      background-image: url(${backgroundSrc});
      background-size: 100% 144px;
      background-position-y: ${backgroundOffset}px;
      background-repeat: no-repeat;

      ::before {
        content: '';
        height: 144px;
        width: 100%;
        background-color: ${$backgroundColor};
        position: absolute;
        top: ${backgroundOffset}px;
        left: 0;
      }
    }
  `}
`;
